import { api, getData, postData, putData } from './request';
import type {
  MaterialSwatch,
  MaterialSwatchCreate,
} from '@cutr/constants/material-swatch';

type MaterialSwatchEdit = Partial<
  Omit<
    MaterialSwatch,
    'id' | 'orderId' | 'createdAt' | 'updatedAt' | 'archivedAt' | 'parts'
  >
>;

export function getMaterialSwatchesForOrder(
  orderId: string,
  signal?: AbortSignal
) {
  return getData<MaterialSwatch[]>('/v2/material-swatches', {
    params: { orderId },
    signal,
  });
}

export function createMaterialSwatch(payload: MaterialSwatchCreate) {
  return postData<MaterialSwatch>('/v2/material-swatches', payload);
}

export function updateMaterialSwatch(id: string, payload: MaterialSwatchEdit) {
  return putData<MaterialSwatch>(`/v2/material-swatches/${id}`, payload);
}

export function assignMaterialSwatch(id: string, partIds: string[]) {
  return postData<MaterialSwatch>(`/v2/material-swatches/${id}/assign`, {
    partIds,
  });
}

export async function deleteMaterialSwatch(id: string): Promise<void> {
  await api.delete(`/v2/material-swatches/${id}`);
}

export async function unassignMaterialSwatch(
  id: string,
  partIds: string[]
): Promise<void> {
  await api.post(`/v2/material-swatches/${id}/unassign`, { partIds });
}
